import React, { useEffect, useState } from "react";
import "./HomeSideNavbar.css";
import { NavLink } from "react-router-dom";

function HomeSideNavbar() {
  const [isVisible, setIsVisible] = useState(false); // for initial slide-in
  const [isMenuOpen, setIsMenuOpen] = useState(false); // for mobile toggle

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  // Close sidebar when a link is clicked (for better UX on mobile)
  const handleLinkClick = () => {
    if (window.innerWidth <= 768) {
      setIsMenuOpen(false);
    }
  };

  return (
    <div className="sidebar-container">
      {/* Hamburger Button */}
      <button className="hamburger-btn" onClick={toggleMenu}>
        {isMenuOpen ? "✖" : "☰"}
      </button>

      <div
        className={`home-sidebar-wrap ${isVisible ? "visible" : ""} ${
          isMenuOpen ? "menu-open" : ""
        }`}
      >
        <div className="sidebar-row">
          {/* ATC-GN */}
          <div className="sideimg-box box2" onClick={handleLinkClick}>
            <a
              href="https://atcgn.lkm.accenture.com/home"
              target="blank"
              rel="noopener noreferrer"
            >
              <img
                src="images/Sidebar/new-icons/ATC-GN.png"
                alt="ATC-GN icon"
                className="white-icon atcgn-icon"
              />
              <img
                src="images/Sidebar/new-icons/ATC-GN-hover.png"
                alt="ATC-GN hover"
                className="grey-icon atcgn-icon-hover"
              />
              <p>ATC-GN</p>
            </a>
          </div>

          {/* GenAI Tools */}
          <div className="sideimg-box box3" onClick={handleLinkClick}>
            <a
              href="https://deepknowledge.accenture.com/genai-compass"
              target="blank"
              rel="noopener noreferrer"
            >
              <img
                src="images/Sidebar/new-icons/gen-compass-icon.png"
                alt="GenAI Tools icon"
                className="white-icon gen-ai-icon"
              />
              <img
                src="images/Sidebar/new-icons/gen-compass-icon-hover.png"
                alt="GenAI Tools hover"
                className="grey-icon gen-ai-icon-hover"
              />
              <p>
                GenAI <br /> Compass
              </p>
            </a>
          </div>

          {/* Contact Us */}
          <div className="sideimg-box box5" onClick={handleLinkClick}>
            <NavLink
              to="/Contact-Us"
              className={({ isActive }) => (isActive ? "is-active" : "")}
            >
              <img
                src="images/Sidebar/new-icons/contact-gray.png"
                alt="Contact Us icon"
                className="white-icon contact-icon"
              />
              <img
                src="images/Sidebar/new-icons/contact-gray-hover.png"
                alt="Contact Us hover"
                className="grey-icon contact-icon-hover"
              />
              <p>
                Contact <br /> Us
              </p>
            </NavLink>
          </div>

          {/* Viva Engage */}
          <div className="sideimg-box box7" onClick={handleLinkClick}>
            <a
              href="https://engage.cloud.microsoft/main/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIyMjYxMDQ2MzEyOTYifQ/new"
              target="blank"
              rel="noopener noreferrer"
            >
              <img
                src="images/Sidebar/new-icons/viva-engage-icon.png"
                alt="Viva Engage icon"
                className="white-icon viva-engage-icon"
              />
              <img
                src="images/Sidebar/new-icons/viva-engage-icon-hover.png"
                alt="Viva Engage hover"
                className="grey-icon viva-engage-icon-hover"
              />
              <p>
                Viva <br /> Engage
              </p>
            </a>
          </div>

          {/* Ask L&TT */}
          <div className="sideimg-box box6" onClick={handleLinkClick}>
            <a
              href="https://teams.microsoft.com/l/app/d023b245-a406-4ed7-88f8-04de099b69f9?source=app-details-dialog&threadId=19%3Acc244f79-5840-4404-8b8b-f02a744010fa_d1da3d5c-50e4-4310-bf8c-88985c3fd75e%40unq.gbl.spaces"
              target="blank"
              rel="noopener noreferrer"
            >
              <img
                src="images/Sidebar/new-icons/chatbot.png"
                alt="logo"
                className="white-icon chatbot-icon"
              />
              <img
                src="images/Sidebar/new-icons/chatbot-hover.png"
                alt="logo"
                className="grey-icon chatbot-icon-hover"
              />
              <p>Ask L&TT</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeSideNavbar;
